import { actionTypes } from "react-redux-firebase";

const initState = {journals: null, journalRows: null}

const journalReducer = (state = initState, action) => {
  switch (action.type) {
    case 'JOURNALS_RETRIEVED':
      console.log('journals retrieved');
      var journalRows = new Array();
      for (var i = 0; i < action.journals.length; i++) {
        journalRows.push(false);
      }
      return {
        ...state,
        journals: action.journals,
        journalRows: journalRows,
        journalsSelectAll: false
      }
    case 'JOURNAL_RETRIEVAL_ERROR':
      console.log('journal retrieval error');
      return state;
    case 'PROJECT_CHANGED':
      return {
        ...state,
        journals: null
      }
    case 'JOURNAL_ROW_SELECTED':
      var journalRows = new Array();
      for (var i = 0; i < action.journalRows.length; i++) {
        journalRows.push(action.journalRows[i]);
      }
      return {
        ...state,
        journalRows: journalRows

      }
    case 'JOURNAL_ROW_SELECTALL':
    return {
      ...state,
      journalsSelectAll: action.selected
      
    }
    case 'JOURNAL_SHOW_POPUP': 
    return {
      ...state,
      showArchivePopup: action.popup
    }
    case 'JOURNAL_SHOW_ASSIGN_POPUP': 
    return {
      ...state,
      showAssignPopup: action.popup,
      assignmentMenuAnchor: action.anchor
    }
    case 'JOURNAL_CHANGE_STATUS_POPUP': 
    return {
      ...state,
      showChangeStatusPopup: action.popup,
      menuAnchor: action.anchor
    }
    case 'JOURNAL_CHANGE_DUE_DATE_POPUP': 
    return {
      ...state,
      showChangeDueDatePopup: action.popup
    }
    case 'JOURNALS_UPDATED':
    return {
      ...state,
      journals: null
    }
    case 'SIGNOUT_SUCCESS':
      console.log('signout success');

      return {
        initState
      }
    default:
      return state;
  }
};

export default journalReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/journalReducer.js